/**
 * hennaDesigns — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const hennaDesignsPack: ToilePack = {
    slug: 'henna-designs',
    category: 'henna',
    name: 'Henna designs',
    tagline: tagline('designs', 'placements', 'styles'),
    chips: chips('placements', 'styles'),
    ratio: A4,
    readings: [
        {key: 'bridal', label: 'Bridal full hand', subject: 'dense from fingertips to forearm, every finger covered'},
        {key: 'starter', label: 'Simple starter', subject: 'one flower with vines onto two fingers'},
        {key: 'foot', label: 'Foot design', subject: 'across the top of the foot, a band at the ankle'},
    ],
    styles: [
        {key: 'indian', label: 'Indian dense', style: 'paisleys, peacocks, mandala rounds and lattice fills', palette: 'dark reddish-brown henna', framing: 'the limb alone, plain pale ground'},
        {key: 'arabic', label: 'Arabic flow', style: 'a bold diagonal vine of open flowers and leaves', palette: 'dark reddish-brown henna', framing: 'the limb alone, plain pale ground'},
        {key: 'minimal', label: 'Modern minimal', style: 'clean geometric lines, dots and one thin band', palette: 'dark reddish-brown henna', framing: 'the limb alone, plain pale ground'},
    ],
    directions: ['with a peacock worked in', 'fewer fills, more open skin', 'a matching wrist band'],
}
